// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root.menu-collapsed {
    --menu-width: var(--menu-width-collapsed);
}

/*-------------------------------------------------------------
	General
-------------------------------------------------------------*/

.main-container {
    margin-left: 15rem;
    /* Top padding is set because the header is now visually present and colored so the content must be padded a bit. */
    padding: 2rem var(--main-content-rl-padding) 3rem var(--main-content-rl-padding);
    /*max-width: 1600px; Removed because of the collapse of the menu*/
    /*-moz-transition: margin-left 0.2s ease-in;  !* FF4+ *!*/
    /*-o-transition: margin-left 0.2s ease-in;  !* Opera 10.5+ *!*/
    /*-webkit-transition: margin-left 0.2s ease-in;  !* Saf3.2+, Chrome *!*/
    /*transition: margin-left 0.2s ease-in;*/
    /*Transition not working well when switching routes*/
}

/*Fix for ng-cloack*/
[ng\\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
    display: none !important;
}

@media (min-width: 576px) {
    .modal-dialog.google-visualization-charteditor-dialog {
        max-width: initial;
    }
}

.google-visualization-charteditor-dialog {
    height: initial !important;
}

.google-visualization-charteditor-dialog .charts-flat-menu-button {
    height: 26px !important;
}

.dropdown-menu-center {
    left: 50% !important;
    right: auto !important;
    text-align: center !important;
    transform: translate(-50%, 0) !important;
}

/*-------------------------------------------------------------
	Headings
-------------------------------------------------------------*/

.rdf-list ul.datasource:before {
    top: 0.5rem;
}

.rdf-side-panel-content ul.rdf-list li.data-key {
    cursor: pointer;
    padding-right: 2.5rem;
}

.container-fluid.main-container.expanded {
    margin-left: 4.375rem;
}

/*-------------------------------------------------------------
	status bar
-------------------------------------------------------------*/
.status-bar {
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: flex-end;
    gap: 0.25em;
    position: sticky;
    top: 0;
    padding-bottom: 0.5em;
    width: max-content;
    max-width: var(--max-width-minus-menu);
    margin-left: auto;
    margin-right: 2em;
    font-size: 1.1em;
    /* below pageslide (position: absolute, z-index: 1000) */
    z-index: 999;
    -moz-transition: all 0.1s ease-out; /* FF4+ */
    -o-transition: all 0.1s ease-out; /* Opera 10.5+ */
    -webkit-transition: all 0.1s ease-out; /* Saf3.2+, Chrome */
    transition: all 0.1s ease-out;
}

/* Hides gap when no monitoring, this doesn't work with :empty */
.status-bar operations-statuses-monitor:not(:has(div)) {
    display: none;
}

.status-bar .btn-group .dropdown-toggle {
    margin-right: 0;
}

/*-------------------------------------------------------------
	sticky footer
-------------------------------------------------------------*/
html {
    position: relative;
    min-height: 100%;
}

footer.footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 30px;
}

footer.footer .container-fluid.main-container {
    padding: 0;
}

footer.footer .container-fluid.main-container p {
    margin: 0;
    padding-left: 30px;
}

/*-------------------------------------------------------------
	Dropdowns
-------------------------------------------------------------*/
.open > .btn-secondary.dropdown-toggle,
.open > .btn-secondary.dropdown-toggle.focus,
.open > .btn-secondary.dropdown-toggle:focus,
.open > .btn-secondary.dropdown-toggle:hover {
    color: #fff;
    background-color: var(--gw-primary-base);
    border-color: var(--gw-primary-base);
}

.open > .btn-secondary.dropdown-toggle [class^="icon-"] {
    color: var(--icon-on-primary-color);
}

.btn-secondary.dropdown-toggle [class^="icon-"] {
    color: var(--gw-primary-base);
}

.dropdown-toggle::after {
    font-family: 'icomoon', sans-serif !important;
    content: "\\e921";
    display: inline-block;
    width: auto;
    height: auto;
    border: none;
    margin-left: 0;
    font-size: 0.9em;
    -moz-transition: all 0.2s ease-in; /* FF4+ */
    -o-transition: all 0.2s ease-in; /* Opera 10.5+ */
    -webkit-transition: all 0.2s ease-in; /* Saf3.2+, Chrome */
    transition: all 0.2s ease-in;
}

.open .dropdown-toggle::after {
    transform: rotate(180deg);
}

.dropdown-menu {
    color: var(--gw-tieredmenu-color);
    background-color: var(--gw-tieredmenu-background);
    border: 1px solid var(--gw-tieredmenu-border-color);
    box-shadow: var(--gw-tieredmenu-shadow-1-offset-x) var(--gw-tieredmenu-shadow-1-offset-y) var(--gw-tieredmenu-shadow-1-blur) var(--gw-tieredmenu-shadow-1-spread) var(--gw-tieredmenu-shadow-1-color);
    border-radius: 0;
    padding: 0;
    min-width: 100%;
    display: none;
    margin-top: -1em;
    opacity: 0;
    -moz-transition: all 150ms ease-out; /* FF4+ */
    -o-transition: all 150ms ease-out; /* Opera 10.5+ */
    -webkit-transition: all 150ms ease-out; /* Saf3.2+, Chrome */
    transition: all 150ms ease-out;
}

.open > .dropdown-menu {
    opacity: 1;
    display: block;
    margin-top: -1px;
}

.dropdown-item {
    color: var(--gw-tieredmenu-item-color) !important;
    padding: 0.5em 1.2em;
    cursor: pointer;
}

.dropdown-item:focus, .dropdown-item:hover {
    color: var(--gw-tieredmenu-item-focus-color);
    background-color: var(--gw-tieredmenu-item-focus-background);
}

.btn-link + .dropdown-menu-right {
    margin-top: 8px;
}

.dropdown-menu-right {
    right: 3px;
}

.status-bar .dropdown-menu-right {
    right: 0;
}
.collapsible-heading {
    cursor: pointer;
}
.collapsible-heading.collapsed [class^=icon-] {
    transform: rotate(-90deg);
}

.rdf-list .hidden-data-value {
    display: none;
}

.tab-error:after {
    font-family: 'icomoon', sans-serif !important;
    font-size: 1em;
    vertical-align: middle;
    line-height: 1;
    position: absolute;
    left: 0.1em;
    content: "\\e920";
}

/*-------------------------------------------------------------
	Tabs
-------------------------------------------------------------*/
.nav-tabs {
    font-weight: 400;
    border-bottom-color: var(--gw-tabs-tablist-border-color);
}

.nav-tabs .nav-item {
    margin-top: 4px;
    margin-right: .2rem;
}

.nav-tabs .nav-item + .nav-item {
    margin-left: 0;
    margin-right: .2rem;
}

.nav-tabs .nav-link {
    border-radius: 0;
    cursor: pointer;
    color: var(--gw-tabs-tab-color);
    background-color: var(--gw-tabs-tab-background);
    border-color: var(--gw-tabs-tab-border-color);
    border-bottom-color: var(--gw-tabs-tab-border-bottom-color);
}

.nav-tabs .nav-link:hover {
    color: var(--gw-tabs-tab-hover-color);
    background-color: var(--gw-tabs-tab-hover-background);
    border-color: var(--gw-tabs-tab-hover-border-color);
    border-bottom-color: var(--gw-tabs-tab-hover-border-bottom-color);
}

.nav-tabs .nav-link .btn {
    padding: 0;
    border: none;
}

.nav-tabs .nav-link > span + .btn {
    margin-left: 0.8em;
}

.nav-tabs .active .nav-link,
.nav-tabs .active.nav-link {
    color: var(--gw-tabs-tab-active-color);
    background-color: var(--gw-tabs-tab-active-background);
    border-color: var(--gw-tabs-tab-active-border-color);
    border-bottom-color: var(--gw-tabs-tab-active-border-bottom-color);
}

.nav-tabs .nav-link.active:hover {
    color: var(--gw-tabs-tab-active-color);
    background-color: var(--gw-tabs-tab-active-background);
    border-color: var(--gw-tabs-tab-active-border-color) var(--gw-tabs-tab-active-border-color) transparent;
}

.nav-tabs .nav-link.active:focus {
    color: var(--gw-tabs-tab-active-color);
    background-color: var(--gw-tabs-tab-active-background);
    border-color: var(--gw-tabs-tab-active-border-color) var(--gw-tabs-tab-active-border-color) transparent;
}

.nav-tabs .nav-item.active a,
.nav-tabs .nav-item.active:focus a,
.nav-tabs .nav-item.active:hover a {
    color: var(--gw-tabs-tab-active-color);
    background-color: var(--gw-tabs-tab-active-background);
    border-color: var(--gw-tabs-tab-active-border-color) var(--gw-tabs-tab-active-border-color) transparent;
}

.nav-tabs .nav-link:focus {
    border-color: var(--gw-tabs-tab-hover-border-color) var(--gw-tabs-tab-hover-border-color) transparent;
}

tab-heading.nav-item {
    margin-right: 4px;
}

/*-------------------------------------------------------------
	Lists
-------------------------------------------------------------*/
ul[class*="style-"] {
    list-style: none;
    padding: 0;
    margin-bottom: 1.2em;
}

ul[class*="style-"] li {
    padding-left: 1.6em;
    position: relative;
    line-height: 1.2;
    margin-bottom: 0.6em;
}

ul[class*="style-"] li:before {
    content: "\\e91b";
    font-family: 'icomoon', sans-serif !important;
    position: absolute;
    left: 0;
    top: -0.07em;
    font-size: 1.2em;
    color: var(--gw-tertiary-base);
}

.text-white ul[class*="style-"] li:before {
    color: #fff;
}

ul.style-caret li:before {
    content: "\\e91b";
}

ul.style-check li:before {
    content: "\\e914";
}

ul.style-arrow li:before {
    content: "\\e902";
}

/*-------------------------------------------------------------
	Tables
-------------------------------------------------------------*/
.table td, .table th {
    padding: .8rem;
    border-color: #ddd;
    vertical-align: middle;
}

.table th {
    font-weight: 500;
    vertical-align: middle;
    color: var(--gw-datatable-header-color);
    background-color: var(--gw-datatable-header-background);
    border-color: var(--gw-datatable-header-cell-border-color);
}

.table tr {
    color: var(--gw-datatable-row-color);
    background-color: var(--gw-datatable-row-background);
}

.table td {
    border-color: var(--gw-datatable-body-cell-border-color);
}

.table-hover tbody tr:hover,
.table-striped tbody tr:nth-of-type(odd):hover {
    background-color: var(--gw-datatable-row-hover-background);
    color: var(--gw-datatable-row-hover-color);
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: var(--gw-datatable-row-striped-background);
}

.table-sm td, .table-sm th {
    padding: 0.3rem 0.5rem;
}

.table-info, .table-info > td, .table-info > th {
    color: var(--gw-datatable-row-selected-color);
    background-color: var(--gw-datatable-row-selected-background);
}

.table-hover .table-info:hover,
.table-hover .table-info:hover > td, .table-hover .table-info:hover > th {
    color: var(--gw-datatable-row-hover-color);
    background-color: var(--gw-datatable-row-hover-background);
}

/*-------------------------------------------------------------
	Modals
-------------------------------------------------------------*/
.modal-content {
    border-radius: var(--gw-dialog-border-radius);
    border: 1px solid var(--gw-dialog-border-color);
    max-height: 90vh;
    flex-direction: column;
    justify-content: space-between;
    display: flex;
    color: var(--gw-dialog-color);
    background-color: var(--gw-dialog-background);
    -webkit-box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);
    box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);

    & pre {
        color: var(--gw-dialog-color);
        background-color: var(--gw-dialog-background);
    }
}

.modal-content .modal-header {
    border-bottom: 1px solid var(--gw-dialog-border-color);
}

.modal-content .modal-header .close {
    margin-top: 4px;
}

.modal-content .modal-header,
.modal-content .modal-footer {
    flex: 0 0 auto;
}

.modal-content .modal-body {
    flex: 1;
    min-height: 0;
    overflow: auto;
}

.modal-content .modal-footer {
    border-top: 1px solid var(--gw-dialog-border-color);
}

/*-------------------------------------------------------------
	Progress bars
-------------------------------------------------------------*/
.progress {
    display: block;
    overflow: hidden;
    font-size: 1.2rem;
    line-height: 2rem;
    height: 2rem;
    background-color: var(--gw-progressbar-background);
}

.progress-bar {
    height: 2rem;
    color: var(--gw-progressbar-label-color);
    background-color: var(--gw-progressbar-value-background);
    padding: 0 0.2em;
    text-align: center;
}

/* Square progress bar */
.progress-square {
    width: 3em;
    height: 3em;
    margin: 0 0.5em 0 0;
    background-color: var(--gw-progressbar-background);
    border-radius: 0.2em;
    overflow: hidden;
    position: relative;
}

.progress-square .progress-bar {
    width: 100%;
    display: block;
    color: var(--gw-progressbar-label-color);
    background-color: var(--gw-progressbar-value-background);
    position: absolute;
    bottom: 0;
}

.progress-square.warning .progress-bar {
    background-color: #f0ad4e;
}

/*-------------------------------------------------------------
	Utilities
-------------------------------------------------------------*/
code {
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    color: inherit;
    background-color: inherit;
}
.d-flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.loader {
    display: inline-block;
    animation: load8 2s infinite linear;
}

.close {
    font-weight: 300;
    font-size: 1.4em;
    opacity: 1;
    text-shadow: none;
}

.close:focus {
    outline: 0;
}

.close::before {
    font-family: 'icomoon', sans-serif !important;
    content: "\\e922";
    -moz-transition: all 0.18s ease-out; /* FF4+ */
    -o-transition: all 0.18s ease-out; /* Opera 10.5+ */
    -webkit-transition: all 0.18s ease-out; /* Saf3.2+, Chrome */
    transition: all 0.18s ease-out;
    display: block;
    color: var(--gw-dialog-color);
}

.close:focus, .close:hover {
    opacity: 1;
}

.close:hover::before {
    transform: scale(1.2);
    color: var(--gw-primary-base);
}

.close.absolute {
    position: absolute;
    right: 1rem;
    top: 1rem;
}

.small, small {
    line-height: 1.25;
}

.break-word {
    word-break: break-all;
}

.break-word-alt {
    word-wrap: break-word;
    word-break: break-word;
}

.data-value {
    color: var(--gw-secondary-base);
    font-weight: 400;
}

.data-value.big {
    display: block;
    font-size: 1.5em;
    line-height: 1;
}

.d-inline-block.valign-top {
    vertical-align: top;
}

.dot-separator:after {
    content: "\\b7"; /* middot */
    margin: 0 0.5em;
}

.dot-separator:last-of-type:after {
    content: none;
    margin: 0;
}

.tag {
    font-weight: 500;
    border-radius: 0;
    vertical-align: 0.1em;
}

.tag-primary {
    background-color: var(--gw-tag-primary-background);
}

.tag-inverse {
    color: rgba(0, 0, 0, 0.7);
}

.text-overflow {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.table .text-overflow {
    max-width: 300px;
}

@media (min-width: 1024px) {
    .table .text-overflow {
        max-width: 450px
    }
}

@media (min-width: 1440px) {
    .table .text-overflow {
        max-width: 650px
    }
}

@media (min-width: 1600px) {
    .table .text-overflow {
        max-width: 850px
    }
}

/*-------------------------------------------------------------
	Cards
-------------------------------------------------------------*/
.card {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    border-radius: 0;
    margin-bottom: 1em;
    color: var(--gw-panel-color);
    background-color: var(--gw-panel-background);
    border-color: var(--gw-panel-border-color);
}

.card-header {
    padding: 0.75em 1.8rem;
    color: var(--gw-panel-header-color);
    background-color: var(--gw-panel-header-background);
}

.card.inline {
    display: inline-block;
    width: 19.5rem;
    margin-right: 1em;
    vertical-align: top;
    overflow: hidden;
}

.card.inline .card-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.card.inline .card-block {
    min-height: 165.19px;
}

.card-block {
    padding: 1.6rem;
}

.card-footer:last-child {
    border-radius: 0;
}

.card.button {
    width: 10em;
}

.card.button:hover {
    border-color: var(--gw-primary-hover-color);
}

.card.button .card-block {
    padding: 0;
}

.card.button .btn {
    white-space: normal;
    padding: 0 1.8rem;
    line-height: 218px;

}

.card.button .btn > span {
    display: inline-block;
    line-height: 1.25;
    vertical-align: middle;
}

.card.button .btn:hover {
    background-color: var(--gw-primary-hover-color);
}

.card.button .btn [class^="icon-"] {
    display: block;
    font-size: 3em;
    margin-bottom: 0.4em;
}

.card.active {
    border-color: var(--gw-secondary-base);
    min-height: 300px;
}

.card.active .card-footer {
    background-color: var(--gw-secondary-base);
    color: #fff;
    border-color: var(--gw-secondary-base);
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.card.active .card-footer .text-muted {
    color: #fff !important;
    font-weight: 500;
}

.card .list-group-item {
    border-left: none;
    border-right: none;
}

.card .alert {
    margin-bottom: 0;
}

.actions-bar .btn {
    padding: 0.1em;
    background-color: transparent;
}

.actions-bar-inline .btn {
    padding-top: 0;
    margin-top: -0.1em;
    padding-bottom: 0.3em;
}

.actions-bar .btn:hover {
}

.hovered-parent .hovered-item {
    opacity: 0;
}

.hovered-parent:hover .hovered-item {
    opacity: 1;
}

/*-------------------------------------------------------------
	Popovers
-------------------------------------------------------------*/
.popover,
.popover pre {
    color: var(--gw-dialog-color);
    background-color: var(--gw-dialog-background);
}

.popover {
    border-radius: 0;
    -webkit-box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);
    box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);
    border: 1px solid var(--gw-dialog-border-color);
    padding: 0;
    font-family: inherit;
}

.popover-content {
    padding: 1em;
}

.popover-title {
    border-radius: 0;
    background-color: var(--gw-dialog-background);
}

/* popover arrows from bootstrap 3 (needed because of angular bootstrap controls which use the old markup) */
.popover.top {
    margin-top: -10px;
}

.popover.right {
    margin-left: 10px;
}

.popover.bottom {
    margin-top: 10px;
}

.popover.left {
    margin-left: -10px;
}

.popover .arrow,
.popover .arrow:after {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
}

.popover .arrow {
    border-width: 11px;
}

.popover .arrow:after {
    border-width: 10px;
    content: "";
}

.popover.top .arrow {
    bottom: -11px;
    left: 50%;
    margin-left: -11px;
    border-top-color: var(--gw-dialog-border-color);
    border-bottom-width: 0;
}

.popover.top .arrow:after {
    bottom: 1px;
    margin-left: -10px;
    border-top-color: var(--gw-dialog-background);
    border-bottom-width: 0;
    content: " ";
}

.popover.right .arrow {
    top: 50%;
    left: -11px;
    margin-top: -11px;
    border-right-color: var(--gw-dialog-border-color);
    border-left-width: 0;
}

.popover.right .arrow:after {
    bottom: -10px;
    left: 1px;
    border-right-color: var(--gw-dialog-background);
    border-left-width: 0;
    content: " ";
}

.popover.bottom .arrow {
    top: -11px;
    left: 50%;
    margin-left: -11px;
    border-bottom-color: var(--gw-dialog-border-color);
    border-top-width: 0;
}

.popover.bottom .arrow:after {
    top: 1px;
    margin-left: -10px;
    border-bottom-color: var(--gw-dialog-background);
    border-top-width: 0;
    content: " ";
}

.popover.left .arrow {
    top: 50%;
    right: -11px;
    margin-top: -11px;
    border-left-color: var(--gw-dialog-border-color);
    border-right-width: 0;
}

.popover.left .arrow:after {
    right: 1px;
    bottom: -10px;
    border-left-color: var(--gw-dialog-background);
    border-right-width: 0;
    content: " ";
}

/*-------------------------------------------------------------
	Tooltips
-------------------------------------------------------------*/
.angular-tooltip {
    max-width: 300px;
    color: var(--gw-tooltip-color);
    background-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-top:after {
    border-top-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-top-left:after {
    border-top-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-top-right:after {
    border-top-color: var(--gw-tooltip-background);
}


.angular-tooltip.angular-tooltip-right-top:after {
    border-right-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-right:after {
    border-right-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-right-bottom:after {
    border-right-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-bottom:after {
    border-bottom-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-bottom-left:after {
    border-bottom-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-bottom-right:after {
    border-bottom-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-left:after {
    border-left-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-left-bottom:after {
    border-left-color: var(--gw-tooltip-background);
}

.angular-tooltip.angular-tooltip-left-top:after {
    border-left-color: var(--gw-tooltip-background);
}

/*-------------------------------------------------------------
	List groups
-------------------------------------------------------------*/
.list-group {
    color: var(--gw-listbox-color);
    background-color: var(--gw-listbox-background);
}

.list-group .list-group-item {
    color: var(--gw-listbox-option-color);
    background-color: var(--gw-listbox-option-group-background);
}

.list-group .list-group-item:hover {
    color: var(--gw-listbox-option-focus-color);
    background-color: var(--gw-listbox-option-focus-background);
}

.list-group-item pre {
    margin-bottom: 0;
}

.list-group.limit-height {
    max-height: 300px;
    overflow-y: auto;
}

.list-group-item samp, .ellipsis-block {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.list-group.two-columns .list-group-item {
    width: 50%;
    float: left;
    border-radius: 0;
}

.list-group.two-columns .list-group-item:first-child,
.list-group.two-columns .list-group-item:nth-child(2) {
    border-top: none;
}

.list-group.two-columns .list-group-item:last-child {
    border-bottom: none;
}

.list-group.two-columns .list-group-item:nth-child(odd) {
    border-right: 1px solid #ddd;
}

.card > .list-group.two-columns:first-child .list-group-item:first-child,
.card > .list-group.two-columns:last-child .list-group-item:last-child {
    border-radius: 0;
}

.list-group.one-column .list-group-item:first-child {
    border-top: none;
}

.list-group.repos li {
    cursor: pointer;
}

li.remote {
    background: #0000000A;
}

/*-------------------------------------------------------------
	Forms
-------------------------------------------------------------*/
.form-control,
.form-control-lg {
    color: var(--gw-form-field-color);
    background-color: var(--gw-form-field-background);
    border-color: var(--gw-form-field-border-color);
}

.form-control[readonly] {
    background-color: var(--gw-form-field-read-only-background);
}

.form-control:focus,
.form-control-lg:focus {
    color: var(--gw-form-field-color);
    background-color: var(--gw-form-field-background);
    border-color: var(--gw-form-field-focus-border-color);
}

.form-control:disabled,
.form-control-lg:disabled {
    color: var(--gw-form-field-disabled-color);
    background-color: var(--gw-form-field-disabled-background);
}

.form-control::placeholder,
.form-control-lg::placeholder {
    color: var(--gw-form-field-placeholder-color);
}

.form-control,
.form-control-lg,
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn {
    border-radius: 0;
}

.form-control-lg,
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn {
    font-size: 1.125rem;
}

.input-group-btn {
    padding-left: 4px;
}

.input-group-addon {
    color: var(--gw-inputgroup-addon-color);
    background-color: var(--gw-inputgroup-addon-background);
    border-radius: 0;
    border: none;
    padding-left: 0;
}

.has-danger .input-group-addon {
    background-color: var(--gw-inputgroup-addon-background);
}

input.ng-invalid.ng-touched, .ng-submitted input.ng-invalid {
    border-color: #d9534f;
}

.input-group-addon.icon {
    background: transparent;
    padding: 0;
    position: absolute;
    top: 3px;
    bottom: 0;
    z-index: 10;
    left: 0.5em;
    pointer-events: none;
    line-height: 2;
}

.input-group-addon.icon + .form-control {
    padding-left: 2.2em;
}

.form-control.b-0 {
    border: 0;
}

fieldset {
    color: var(--gw-fieldset-color);
}

/* Override checkbox and radio button styles because they inherit their look from the OS which makes them ugly and
unresponsive to our theme. */
input[type="checkbox"],
input[type="radio"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: var(--gw-form-field-color);
    background-color: var(--gw-form-field-background);
    border: 1px solid var(--gw-form-field-border-color);
    width: 1em;
    height: 1em;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
}

input[type="radio"] {
    border-radius: 50%;
}

input[type="checkbox"]:checked {
    background-color: var(--gw-primary-base);
    border-color: var(--gw-primary-base);
}

input[type="radio"]:checked {
    border-color: var(--gw-primary-base);
}

input[type="checkbox"]:checked::after {
    content: "\\2713"; /* checkmark */
    display: block;
    text-align: center;
    color: var(--gw-body-background);
    font-size: 0.8em;
    line-height: 1.2;
}

input[type="radio"]:checked::after {
    content: "";
    display: block;
    width: 0.5em;
    height: 0.5em;
    border-radius: 50%;
    background-color: var(--gw-primary-base);
    margin: 0.2em;
}

input[type=checkbox]:checked:disabled {
    background-color: var(--gw-checkbox-checked-disabled-background);
    border-color: var(--gw-checkbox-checked-disabled-border-color);
}

    /*-------------------------------------------------------------
        List groups
    -------------------------------------------------------------*/

.list-group-item:last-child,
.list-group-item:first-child {
    border-radius: 0;
}

.border-top-0 .list-group-item:first-child {
    border-top: 0;
}

.tuclas .tooltip-inner {
    color: #880000;
    background-color: #ffff66;
    box-shadow: 0 6px 12px rgba(0,0,0,.175);
    /*max-height: 30px;*/
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    /*width: 100px;*/
    /*word-wrap: unset;*/
    /*white-space: unset;*/
}
/*-------------------------------------------------------------
	Switch control
-------------------------------------------------------------*/


span.switch {
    clear: both;
    margin: 0 5px;
    width: 36px;
}

input.switch:empty {
    display: none
}

input.switch:empty ~ label {
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin: 0.05em 0.6em -0.05em 0;
    vertical-align: text-bottom;
}

input.switch:empty ~ label:before {
    display: block;
    content: ' ';
    width: 2.2em;
    height: 1.25em;
    background-color: var(--gw-toggleswitch-background);
    border-radius: 10em;
    -moz-transition: all 100ms ease-in; /* FF4+ */
    -o-transition: all 100ms ease-in; /* Opera 10.5+ */
    -webkit-transition: all 100ms ease-in; /* Saf3.2+, Chrome */
    transition: all 100ms ease-in;
}

input.switch:empty ~ label:after {
    position: absolute;
    display: block;
    top: 0.1em;
    left: 0.1em;
    content: ' ';
    width: 1.05em;
    height: 1.05em;
    background-color: var(--gw-toggleswitch-handle-background);
    border-radius: 50%;
    -moz-transition: all 100ms ease-in; /* FF4+ */
    -o-transition: all 100ms ease-in; /* Opera 10.5+ */
    -webkit-transition: all 100ms ease-in; /* Saf3.2+, Chrome */
    transition: all 100ms ease-in;
}

input.switch:empty ~ label:hover:after {
    background-color: var(--gw-toggleswitch-handle-hover-background);
}

input.switch:checked ~ label:before {
    background-color: var(--gw-toggleswitch-checked-background);
}

input.switch:checked ~ label:hover:before {
    background-color: var(--gw-toggleswitch-checked-hover-background);
}

input.switch:checked ~ label:after {
    left: 1.05em;
    background-color: var(--gw-toggleswitch-handle-checked-background);
}

input.switch:checked ~ label:hover:after {
    background-color: var(--gw-toggleswitch-handle-checked-hover-background);
}

.card.active input.switch:checked ~ label:before {
    background-color: rgba(255, 255, 255, .5);
}

.card.active input.switch:checked ~ label:after {
    background-color: #fff;
}

/*-------------------------------------------------------------
	Angular Toaster messages
-------------------------------------------------------------*/
#toast-container .toast {
    border-radius: 0;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
    position: relative;
}

#toast-container > :hover {
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.6);
}

#toast-container > div:before {
    display: block;
    font-family: 'icomoon', sans-serif !important;
    font-size: 2em;
    position: absolute;
    left: 0.3em;
    top: 0.1em;
}

#toast-container .toast.toast-error,
#toast-container .toast.toast-warning,
#toast-container .toast.toast-info,
#toast-container .toast.toast-success {
    background-image: none !important;
}

#toast-container .toast {
    font-size: 1.2rem;
    opacity: 1;
    padding: 25px 25px 25px 60px;
    width: 450px;
}

@media (max-width: 1439px) {
    #toast-container .toast {
        width: 400px;
    }
}

.toast-error {
    background-color: var(--gw-toast-error-background) !important;
    border-color: var(--gw-toast-error-border-color) !important;
    color: var(--gw-toast-error-color) !important;
}

.toast-error button.toast-close-button {
    color: var(--gw-toast-error-color);
    opacity: 1;
}

.toast-error button.toast-close-button:hover {
    color: var(--gw-toast-error-close-button-focus-ring-color);
}

.toast-warning {
    background-color: var(--gw-toast-warn-background) !important;
    border-color: var(--gw-toast-warn-border-color) !important;
    color: var(--gw-toast-warn-color) !important;
}

.toast-warning button.toast-close-button {
    color: var(--gw-toast-warn-color);
    opacity: 1;
}

.toast-warning button.toast-close-button:hover {
    color: var(--gw-toast-warn-close-button-focus-ring-color);
}

.toast-info {
    background-color: var(--gw-toast-info-background) !important;
    border-color: var(--gw-toast-info-border-color) !important;
    color: var(--gw-toast-info-color) !important;
}

.toast-info button.toast-close-button {
    color: var(--gw-toast-info-color);
    opacity: 1;
}

.toast-info button.toast-close-button:hover {
    color: var(--gw-toast-info-close-button-focus-ring-color);
}

.toast-success {
    background-color: var(--gw-toast-success-background) !important;
    border-color: var(--gw-toast-success-border-color) !important;
    color: var(--gw-toast-success-color) !important;
}

.toast-success button.toast-close-button {
    color: var(--gw-toast-success-color);
    opacity: 1;
}

.toast-success button.toast-close-button:hover {
    color: var(--gw-toast-success-close-button-focus-ring-color);
}

.toast-error:before,
.toast-warning:before,
.toast-info:before,
.toast-success:before {
    font-family: 'icomoon', sans-serif !important;
    font-size: 1.5em;
    position: absolute;
    left: 0.6em;
    display: block;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}

.toast-info:before {
    content: "\\e924";
}

.toast-warning:before {
    content: "\\e930";
}

.toast-error:before {
    content: "\\e920";
}

.toast-success:before {
    content: "\\e914";
}


#toast-container > .toast-error:before,
#toast-container > .toast-warning:before {
    content: "\\e920";
}

#toast-container > .toast-success:before {
    content: "\\e914";
}

#toast-container > .toast-info:before {
    content: "\\e924";
}

#toast-container > .toast-info {
    background-color: #10b0a0;
}

#toast-container > :hover {
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.5) !important;
}

#toast-container .toast-title {
    font-weight: 500;
}

/*-------------------------------------------------------------
	Tutorial
-------------------------------------------------------------*/

.pages-wrapper {
    position: relative;
    overflow: hidden;
}

.page-slide {
    position: absolute;
    -moz-transition: left 0.18s ease-out; /* FF4+ */
    -o-transition: left 0.18s ease-out; /* Opera 10.5+ */
    -webkit-transition: left 0.18s ease-out; /* Saf3.2+, Chrome */
    transition: left 0.18s ease-out;
}

.tutorial-container .pages-wrapper {
    min-height: 300px;
}

.page-slide ul {
    list-style-type: none;
    margin-top: 16px;
}

/*-------------------------------------------------------------
	Search RDF resource box
-------------------------------------------------------------*/

#auto-complete-results-wrapper {
    max-height: 204px;
    overflow: auto;
    color: var(--gw-autocomplete-color);
    background-color: var(--gw-autocomplete-background);
}

#auto-complete-results-wrapper div:hover,
#auto-complete-results-wrapper div.active {
    color: var(--gw-autocomplete-option-focus-color);
    background-color: var(--gw-autocomplete-option-focus-background);
    cursor: pointer;
}

#auto-complete-results-wrapper div.selected {
    color: var(--gw-autocomplete-option-selected-color);
    background-color: var(--gw-autocomplete-option-selected-background);
    cursor: pointer;
}

#auto-complete-results-wrapper div p b,
#auto-complete-results-wrapper div.active p b {
    color: var(--gw-autocomplete-dropdown-match-color);
}

#auto-complete-results-wrapper div p {
    margin-bottom: 0;
    padding: 5px 25px;
}

#search-resource-box {
    .clear-icon {
        position: relative;
        right: 45px;
        z-index: 10;
        float: none;
    }

    .display-type-table-btn.active,
    .display-type-visual-btn.active {
        color: var(--gw-button-primary-hover-color);
        background-color: var(--gw-button-primary-background);
        border-color: var(--gw-button-primary-border-color);
    }
}

/*-------------------------------------------------------------
	Animations
-------------------------------------------------------------*/
@keyframes load8 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(-360deg);
        transform: rotate(-360deg);
    }
}

/*-------------------------------------------------------------
	Paggination - Export view
-------------------------------------------------------------*/

ul.nav.navbar-right.pagination li {
    float: left;
}

ul.nav.navbar-right.pagination li:hover a {
    text-decoration: none;
}

ul.nav.navbar-right.pagination li.disabled a {
    color: rgba(0, 0, 0, 0.5) !important;
    pointer-events: none;
}

/*-------------------------------------------------------------
	Paggination
-------------------------------------------------------------*/
.pagination > li > a {
    color: var(--gw-paginator-nav-button-color);
    background-color: var(--gw-paginator-nav-button-background);
}

.pagination > .active > a {
    color: var(--gw-paginator-nav-button-selected-color);
    background-color: var(--gw-paginator-nav-button-selected-background);
}

.pagination > li > a:hover {
    color: var(--gw-paginator-nav-button-hover-color);
    background-color: var(--gw-paginator-nav-button-hover-background);
}

@media (max-width: 1439px) {
    .yasr .dataTables_wrapper .dataTables_filter input, .yasr .openGchartBtn {
        margin-top: 8px;
    }
}

.yasr .pivotTable {
    overflow-y: auto;
}

.btn.btn-primary.btn-sm.yasr_downloadIcon {
    margin-right: 6px;
}

/*-------------------------------------------------------------
	Save as dropdown yasr SPARQL
-------------------------------------------------------------*/

.saveAsDropDown.btn-group .btn.btn-primary.btn-sm.dropdown-toggle, .yasr_downloadIcon, .resultsVisualButton button {
    font-size: 16px;
    padding: 10px 16px;
    margin-top: 4px;
}

/*-------------------------------------------------------------
	SPARQL editor
-------------------------------------------------------------*/
.dialog .dialog-footer .confirm-button {
    background-color: var(--gw-primary-base) !important;
}


yasgui-component .yasgui-btn.btn-selected {
    background-color: var(--gw-primary-base) !important;
}

yasgui-component .btn-orientation {
    color: var(--gw-primary-base) !important;
}

yasgui-component .custom-button {
    color: var(--gw-primary-base) !important;
}

yasgui-component .ok-button,
yasgui-component .primary-button,
yasgui-component .confirm-button {
    background-color: var(--gw-primary-base) !important;
}

yasgui-component .yasr .dataTable a {
    font-size: 16px;
}

yasgui-component .yasr_response_chip {
    font-size: 16px;
    color: var(--gw-secondary-base) !important;
}

yasgui-component .yasr_plugin_control label {
    color: var(--gw-secondary-base) !important;
    margin-bottom: 0;
}

yasgui-component .yasr_plugin_control label .label {
    margin-right: 5px;
}

/* End of yasgui-component style overrides */
.dialog .dialog-footer .confirm-button {
    background-color: var(--gw-primary-base) !important;
}

.nav-item.sparql-tab a.nav-link {
    max-width: 250px;
    padding-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
}

.nav-item.sparql-tab a.nav-link .btn.btn-link {
    position: absolute;
    right: 4px;
    top: 11px;
}

.nav-item.sparql-tab a.nav-link span {
    padding-right: 10px;
}

/*-------------------------------------------------------------
    Namespaces view
-------------------------------------------------------------*/
input[name=namespace] {
    width: 55%;
    float: left;
}

.showing-info-namespaces {
    margin-top: 16px;
}

/*-------------------------------------------------------------
    Domain-Range graph side menu
-------------------------------------------------------------*/

.rdf-side-panel-content ul.rdf-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.rdf-side-panel-content ul.rdf-list li {
    position: relative;
    padding: 5px 50px 5px 10px;
}

.rdf-side-panel-content ul.rdf-list li svg {
    position: absolute;
    top: 50%;
    right: 10px;
    pointer-events: none;
}

.rdf-side-panel-content ul.rdf-list li:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05);

}

.rdf-side-panel-content ul.rdf-list li {
    border-top: 1px solid #ddd;
    padding: 10px;
}

/*-------------------------------------------------------------
    Class hierarchy view
-------------------------------------------------------------*/

.slider-help-button .help-button {
    padding: 0;
    position: absolute;
    right: -25px;
    top: -1px;
}

.slider-help-button .help-button .ri-information-2-line {
    font-size: 1.2em;
}

.slider-help-button {
    position: relative;
    left: -16px;
}

/*-------------------------------------------------------------
    Internet explorer fixes
-------------------------------------------------------------*/

/*Disable search graphs input clear and input reveal*/
::-ms-clear {
    display: none;
}

::-ms-reveal {
    display: none;
}

/*-------------------------------------------------------------
    Slide up and down view resource container
-------------------------------------------------------------*/

.slider {
    overflow-y: hidden;
}

.slider.closed {
    max-height: 0;
    -moz-transition: max-height 0.5s ease-out; /* FF4+ */
    -o-transition: max-height 0.5s ease-out; /* Opera 10.5+ */
    -webkit-transition: max-height 0.5s ease-out; /* Saf3.2+, Chrome */
    transition: max-height 0.5s ease-out;
}

.slider.opened {
    -moz-transition: max-height 0.5s ease-in; /* FF4+ */
    -o-transition: max-height 0.5s ease-in; /* Opera 10.5+ */
    -webkit-transition: max-height 0.5s ease-in; /* Saf3.2+, Chrome */
    transition: max-height 0.5s ease-in;
}

/*-------------------------------------------------------------
    Graphs visualizations side panel
-------------------------------------------------------------*/

.rdf-side-panel-content .tab-content {
    overflow-y: auto;
    width: 100%;
    max-height: calc(100vh - 130px);
}

.menu-events g {
    cursor: pointer;
    opacity: 0;
}

.tags .tag-list li.tag-item {
    height: auto !important;
    white-space: normal !important;
}


/*-------------------------------------------------------------
    Badges
-------------------------------------------------------------*/
.badge {
    display: inline-block;
    padding: .25em .4em;
    font-size: 75%;
    font-weight: 400;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25rem;
}
.badge-default  { background-color: #aaa }
.badge-primary  { background-color: var(--gw-secondary-base) }
.badge-info     { background-color: var(--gw-primary-base) }
.badge-success  { background-color: #5cb85c }
.badge-warning  { background-color: #f0ad4e }

/*-------------------------------------------------------------
    Columns
-------------------------------------------------------------*/
@media (min-width: 992px) {
    .col-lg-no-padding {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
}

/*-------------------------------------------------------------
    Custom tags-input styling, overrides some
    of the styles from ng-tags-input.min.css
-------------------------------------------------------------*/
tags-input[disabled] .tags {
    color: var(--gw-form-field-disabled-color);
    background-color: var(--gw-form-field-disabled-background) !important;
}

tags-input[disabled] .tags .input {
    color: var(--gw-form-field-disabled-color);
    background-color: var(--gw-form-field-disabled-background) !important;
}

tags-input .tags .input {
    color: var(--gw-form-field-color);
    background-color: var(--gw-form-field-background);
}

.wb-tags-input .tags {
    background-color: var(--gw-form-field-background);
    border: 1px solid var(--gw-form-field-border-color);
    border-radius: 0;
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

.wb-tags-input .tags.focused {
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #cbeeea;
    -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #cbeeea;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #cbeeea;
}

.wb-tags-input .tags .tag-item {
    background: #cbeeea;
    border: 1px solid #cbeeea;
    border-radius: 0;
    color: #3D3D3D;
}

.wb-tags-input .tags .tag-item.tag-item-wildcard {
    background: #cbeeea;
    border: 1px solid #cbeeea;
    border-radius: 0;
    color: #3D3D3D;
    font-weight: bold;
}

.wb-tags-input .tags .tag-item .remove-button {
    margin: 0 0 0 5px;
    padding: 0;
    border: none;
    background: 0 0;
    cursor: pointer;
    vertical-align: middle;
    font: 700 16px Arial,sans-serif;
    color: #7e7b6d;
}

/*-------------------------------------------------------------
	Main menu
-------------------------------------------------------------*/
.repo-info-home {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}

.repo-info-home div {
    align-self: center;
}

.tag-default {
    color: var(--gw-tag-default-color) !important;
    background-color: var(--gw-tag-default-background) !important;
}

.tag-danger {
    color: var(--gw-tag-danger-color) !important;
    background-color: var(--gw-tag-danger-background) !important;
}

.tag-success {
    color: var(--gw-tag-success-color) !important;
    background-color: var(--gw-tag-success-background) !important;
}

.tag-warning {
    color: var(--gw-tag-warning-color) !important;
    background-color: var(--gw-tag-warning-background) !important;
}

.tag-info {
    color: var(--gw-tag-info-color) !important;
    background-color: var(--gw-tag-info-background) !important;
}

.rzslider .rz-pointer {
    background-color: var(--gw-slider-handle-focus-ring-color) !important;
    outline: none !important;
}

.rzslider .rz-pointer:hover {
    background-color: var(--gw-slider-handle-hover-background) !important;
}

.rzslider .rz-pointer:after {
    background-color: var(--gw-slider-track-background) !important;
}

.rzslider .rz-pointer.rz-active:after {
    background-color: var(--gw-slider-range-background) !important;
}

.rzslider .rz-bar {
    background-color: var(--gw-slider-track-background) !important;
}

.rzslider .rz-selection {
    background: var(--gw-slider-range-background) !important;
}

.rzslider .rz-bubble.rz-limit,
.rzslider .rz-bubble {
    color: var(--gw-slider-label-color) !important;
}

.login-form {
    max-width: 600px;
    padding-top: 4em;
    margin: auto;
}

.btn-fade-warning {
    animation: fade-button 2s infinite;
    --fade-color: var(--gw-warning-lighter);
}

.btn-fade-danger {
    animation: fade-button 2s infinite;
    --fade-color: var(--gw-error-lighter);
}

.btn-fade-warning:hover, .btn-fade-danger:hover {
    background-color: var(--fade-color) !important;
    border-color: var(--fade-color) !important;
}

@keyframes fade-button {
    from {
        background-color: transparent;
        border-color: transparent;
    }
    50% {
        background-color: var(--fade-color);
        border-color: var(--fade-color);
    }
    to {
        background-color: transparent;
        border-color: transparent;
    }
}

.ot-loader-new-content circle {
    fill: var(--gw-loader-color)
}
`, "",{"version":3,"sources":["webpack://./packages/legacy-workbench/src/css/bootstrap-graphdb-theme.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;;AAEA;;8DAE8D;;AAE9D;IACI,kBAAkB;IAClB,mHAAmH;IACnH,gFAAgF;IAChF,iEAAiE;IACjE,yDAAyD;IACzD,8DAA8D;IAC9D,uEAAuE;IACvE,wCAAwC;IACxC,oDAAoD;AACxD;;AAEA,oBAAoB;AACpB;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;IAC7B,wCAAwC;AAC5C;;AAEA;;8DAE8D;;AAE9D;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;8DAE8D;AAC9D;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,MAAM;IACN,qBAAqB;IACrB,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,wDAAwD;IACxD,YAAY;IACZ,kCAAkC,EAAE,SAAS;IAC7C,gCAAgC,EAAE,gBAAgB;IAClD,qCAAqC,EAAE,oBAAoB;IAC3D,6BAA6B;AACjC;;AAEA,gEAAgE;AAChE;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;8DAE8D;AAC9D;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;;8DAE8D;AAC9D;;;;IAII,WAAW;IACX,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iCAAiC,EAAE,SAAS;IAC5C,+BAA+B,EAAE,gBAAgB;IACjD,oCAAoC,EAAE,oBAAoB;IAC1D,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,iDAAiD;IACjD,mDAAmD;IACnD,qMAAqM;IACrM,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,mCAAmC,EAAE,SAAS;IAC9C,iCAAiC,EAAE,gBAAgB;IACnD,sCAAsC,EAAE,oBAAoB;IAC5D,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,4CAA4C;IAC5C,4DAA4D;AAChE;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,QAAQ;AACZ;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6CAA6C;IAC7C,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;;8DAE8D;AAC9D;IACI,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,+CAA+C;IAC/C,6CAA6C;IAC7C,2DAA2D;AAC/D;;AAEA;IACI,qCAAqC;IACrC,qDAAqD;IACrD,mDAAmD;IACnD,iEAAiE;AACrE;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,sCAAsC;IACtC,sDAAsD;IACtD,oDAAoD;IACpD,kEAAkE;AACtE;;AAEA;IACI,sCAAsC;IACtC,sDAAsD;IACtD,uGAAuG;AAC3G;;AAEA;IACI,sCAAsC;IACtC,sDAAsD;IACtD,uGAAuG;AAC3G;;AAEA;;;IAGI,sCAAsC;IACtC,sDAAsD;IACtD,uGAAuG;AAC3G;;AAEA;IACI,qGAAqG;AACzG;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;8DAE8D;AAC9D;IACI,gBAAgB;IAChB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,6CAA6C;IAC7C,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;8DAE8D;AAC9D;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,uCAAuC;IACvC,uDAAuD;IACvD,0DAA0D;AAC9D;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;AACxD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;;IAEI,0DAA0D;IAC1D,0CAA0C;AAC9C;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;IAC7C,6DAA6D;AACjE;;AAEA;;IAEI,0CAA0C;IAC1C,0DAA0D;AAC9D;;AAEA;;8DAE8D;AAC9D;IACI,6CAA6C;IAC7C,+CAA+C;IAC/C,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,6BAA6B;IAC7B,6CAA6C;IAC7C,yLAAyL;IACzL,iLAAiL;;IAEjL;QACI,6BAA6B;QAC7B,6CAA6C;IACjD;AACJ;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;;8DAE8D;AAC9D;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,wDAAwD;IACxD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kDAAkD;IAClD,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,wCAAwC;IACxC,wDAAwD;IACxD,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;8DAE8D;AAC9D;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,mCAAmC,EAAE,SAAS;IAC9C,iCAAiC,EAAE,gBAAgB;IACnD,sCAAsC,EAAE,oBAAoB;IAC5D,8BAA8B;IAC9B,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc,EAAE,WAAW;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;8DAE8D;AAC9D;IACI,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,4CAA4C;IAC5C,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,sCAAsC;IACtC,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;AACA;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;8DAE8D;AAC9D;;IAEI,6BAA6B;IAC7B,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,yLAAyL;IACzL,iLAAiL;IACjL,+CAA+C;IAC/C,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA,4GAA4G;AAC5G;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6CAA6C;IAC7C,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,iDAAiD;IACjD,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,+CAA+C;IAC/C,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,gDAAgD;IAChD,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,8CAA8C;IAC9C,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;8DAE8D;AAC9D;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;;AAGA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;;8DAE8D;AAC9D;IACI,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;IACrC,2DAA2D;AAC/D;;AAEA;IACI,2CAA2C;IAC3C,2DAA2D;AAC/D;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;8DAE8D;AAC9D;;IAEI,iCAAiC;IACjC,iDAAiD;IACjD,+CAA+C;AACnD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;;IAEI,iCAAiC;IACjC,iDAAiD;IACjD,qDAAqD;AACzD;;AAEA;;IAEI,0CAA0C;IAC1C,0DAA0D;AAC9D;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;;;;;IAKI,gBAAgB;AACpB;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,uDAAuD;IACvD,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,+BAA+B;AACnC;;AAEA;4BAC4B;AAC5B;;IAEI,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,iCAAiC;IACjC,iDAAiD;IACjD,mDAAmD;IACnD,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB,EAAE,cAAc;IAChC,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,gEAAgE;IAChE,8DAA8D;AAClE;;IAEI;;kEAE8D;;AAElE;;IAEI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,uCAAuC;IACvC,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;;IAEnB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;;8DAE8D;;;AAG9D;IACI,WAAW;IACX,aAAa;IACb,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mDAAmD;IACnD,mBAAmB;IACnB,kCAAkC,EAAE,SAAS;IAC7C,gCAAgC,EAAE,gBAAgB;IAClD,qCAAqC,EAAE,oBAAoB;IAC3D,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,0DAA0D;IAC1D,kBAAkB;IAClB,kCAAkC,EAAE,SAAS;IAC7C,gCAAgC,EAAE,gBAAgB;IAClD,qCAAqC,EAAE,oBAAoB;IAC3D,6BAA6B;AACjC;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,iEAAiE;AACrE;;AAEA;IACI,YAAY;IACZ,kEAAkE;AACtE;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;8DAE8D;AAC9D;IACI,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,6CAA6C;IAC7C,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;;;;IAII,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,6DAA6D;IAC7D,2DAA2D;IAC3D,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,4DAA4D;IAC5D,0DAA0D;IAC1D,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,4DAA4D;IAC5D,0DAA0D;IAC1D,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,+DAA+D;IAC/D,6DAA6D;IAC7D,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,4DAA4D;AAChE;;AAEA;;;;IAII,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,QAAQ;IACR,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;8DAE8D;;AAE9D;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC,EAAE,SAAS;IAC/C,kCAAkC,EAAE,gBAAgB;IACpD,uCAAuC,EAAE,oBAAoB;IAC7D,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;8DAE8D;;AAE9D;IACI,iBAAiB;IACjB,cAAc;IACd,mCAAmC;IACnC,mDAAmD;AACvD;;AAEA;;IAEI,gDAAgD;IAChD,gEAAgE;IAChE,eAAe;AACnB;;AAEA;IACI,mDAAmD;IACnD,mEAAmE;IACnE,eAAe;AACnB;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,WAAW;IACf;;IAEA;;QAEI,2CAA2C;QAC3C,qDAAqD;QACrD,mDAAmD;IACvD;AACJ;;AAEA;;8DAE8D;AAC9D;IACI;QACI,+BAA+B;QAC/B,uBAAuB;IAC3B;IACA;QACI,kCAAkC;QAClC,0BAA0B;IAC9B;AACJ;;AAEA;;8DAE8D;;AAE9D;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;;8DAE8D;AAC9D;IACI,2CAA2C;IAC3C,2DAA2D;AAC/D;;AAEA;IACI,oDAAoD;IACpD,oEAAoE;AACxE;;AAEA;IACI,iDAAiD;IACjD,iEAAiE;AACrE;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;8DAE8D;;AAE9D;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;8DAE8D;AAC9D;IACI,mDAAmD;AACvD;;;AAGA;IACI,mDAAmD;AACvD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;;IAGI,mDAAmD;AACvD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,4CAA4C;AAC5C;IACI,mDAAmD;AACvD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;8DAE8D;AAC9D;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;8DAE8D;;AAE9D;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;IACI,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;;8DAE8D;;AAE9D;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;8DAE8D;;AAE9D,qDAAqD;AACrD;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;8DAE8D;;AAE9D;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yCAAyC,EAAE,SAAS;IACpD,uCAAuC,EAAE,gBAAgB;IACzD,4CAA4C,EAAE,oBAAoB;IAClE,oCAAoC;AACxC;;AAEA;IACI,wCAAwC,EAAE,SAAS;IACnD,sCAAsC,EAAE,gBAAgB;IACxD,2CAA2C,EAAE,oBAAoB;IACjE,mCAAmC;AACvC;;AAEA;;8DAE8D;;AAE9D;IACI,gBAAgB;IAChB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;;AAGA;;8DAE8D;AAC9D;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;AACzB;AACA,kBAAkB,uBAAuB;AACzC,kBAAkB,2CAA2C;AAC7D,kBAAkB,yCAAyC;AAC3D,kBAAkB,0BAA0B;AAC5C,kBAAkB,0BAA0B;;AAE5C;;8DAE8D;AAC9D;IACI;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;AACJ;;AAEA;;;8DAG8D;AAC9D;IACI,0CAA0C;IAC1C,qEAAqE;AACzE;;AAEA;IACI,0CAA0C;IAC1C,qEAAqE;AACzE;;AAEA;IACI,iCAAiC;IACjC,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;IACjD,mDAAmD;IACnD,gBAAgB;IAChB,6CAA6C;IAC7C,sEAAsE;AAC1E;;AAEA;IACI,UAAU;IACV,yEAAyE;IACzE,sEAAsE;IACtE,iEAAiE;AACrE;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;;8DAE8D;AAC9D;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;IAC7C,6DAA6D;AACjE;;AAEA;IACI,4CAA4C;IAC5C,4DAA4D;AAChE;;AAEA;IACI,6CAA6C;IAC7C,6DAA6D;AACjE;;AAEA;IACI,6CAA6C;IAC7C,6DAA6D;AACjE;;AAEA;IACI,0CAA0C;IAC1C,0DAA0D;AAC9D;;AAEA;IACI,qEAAqE;IACrE,wBAAwB;AAC5B;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI;QACI,6BAA6B;QAC7B,yBAAyB;IAC7B;IACA;QACI,mCAAmC;QACnC,+BAA+B;IACnC;IACA;QACI,6BAA6B;QAC7B,yBAAyB;IAC7B;AACJ;;AAEA;IACI;AACJ","sourcesContent":[":root.menu-collapsed {\n    --menu-width: var(--menu-width-collapsed);\n}\n\n/*-------------------------------------------------------------\n\tGeneral\n-------------------------------------------------------------*/\n\n.main-container {\n    margin-left: 15rem;\n    /* Top padding is set because the header is now visually present and colored so the content must be padded a bit. */\n    padding: 2rem var(--main-content-rl-padding) 3rem var(--main-content-rl-padding);\n    /*max-width: 1600px; Removed because of the collapse of the menu*/\n    /*-moz-transition: margin-left 0.2s ease-in;  !* FF4+ *!*/\n    /*-o-transition: margin-left 0.2s ease-in;  !* Opera 10.5+ *!*/\n    /*-webkit-transition: margin-left 0.2s ease-in;  !* Saf3.2+, Chrome *!*/\n    /*transition: margin-left 0.2s ease-in;*/\n    /*Transition not working well when switching routes*/\n}\n\n/*Fix for ng-cloack*/\n[ng\\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {\n    display: none !important;\n}\n\n@media (min-width: 576px) {\n    .modal-dialog.google-visualization-charteditor-dialog {\n        max-width: initial;\n    }\n}\n\n.google-visualization-charteditor-dialog {\n    height: initial !important;\n}\n\n.google-visualization-charteditor-dialog .charts-flat-menu-button {\n    height: 26px !important;\n}\n\n.dropdown-menu-center {\n    left: 50% !important;\n    right: auto !important;\n    text-align: center !important;\n    transform: translate(-50%, 0) !important;\n}\n\n/*-------------------------------------------------------------\n\tHeadings\n-------------------------------------------------------------*/\n\n.rdf-list ul.datasource:before {\n    top: 0.5rem;\n}\n\n.rdf-side-panel-content ul.rdf-list li.data-key {\n    cursor: pointer;\n    padding-right: 2.5rem;\n}\n\n.container-fluid.main-container.expanded {\n    margin-left: 4.375rem;\n}\n\n/*-------------------------------------------------------------\n\tstatus bar\n-------------------------------------------------------------*/\n.status-bar {\n    display: flex;\n    flex-wrap: wrap-reverse;\n    justify-content: flex-end;\n    gap: 0.25em;\n    position: sticky;\n    top: 0;\n    padding-bottom: 0.5em;\n    width: max-content;\n    max-width: var(--max-width-minus-menu);\n    margin-left: auto;\n    margin-right: 2em;\n    font-size: 1.1em;\n    /* below pageslide (position: absolute, z-index: 1000) */\n    z-index: 999;\n    -moz-transition: all 0.1s ease-out; /* FF4+ */\n    -o-transition: all 0.1s ease-out; /* Opera 10.5+ */\n    -webkit-transition: all 0.1s ease-out; /* Saf3.2+, Chrome */\n    transition: all 0.1s ease-out;\n}\n\n/* Hides gap when no monitoring, this doesn't work with :empty */\n.status-bar operations-statuses-monitor:not(:has(div)) {\n    display: none;\n}\n\n.status-bar .btn-group .dropdown-toggle {\n    margin-right: 0;\n}\n\n/*-------------------------------------------------------------\n\tsticky footer\n-------------------------------------------------------------*/\nhtml {\n    position: relative;\n    min-height: 100%;\n}\n\nfooter.footer {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    height: 30px;\n}\n\nfooter.footer .container-fluid.main-container {\n    padding: 0;\n}\n\nfooter.footer .container-fluid.main-container p {\n    margin: 0;\n    padding-left: 30px;\n}\n\n/*-------------------------------------------------------------\n\tDropdowns\n-------------------------------------------------------------*/\n.open > .btn-secondary.dropdown-toggle,\n.open > .btn-secondary.dropdown-toggle.focus,\n.open > .btn-secondary.dropdown-toggle:focus,\n.open > .btn-secondary.dropdown-toggle:hover {\n    color: #fff;\n    background-color: var(--gw-primary-base);\n    border-color: var(--gw-primary-base);\n}\n\n.open > .btn-secondary.dropdown-toggle [class^=\"icon-\"] {\n    color: var(--icon-on-primary-color);\n}\n\n.btn-secondary.dropdown-toggle [class^=\"icon-\"] {\n    color: var(--gw-primary-base);\n}\n\n.dropdown-toggle::after {\n    font-family: 'icomoon', sans-serif !important;\n    content: \"\\e921\";\n    display: inline-block;\n    width: auto;\n    height: auto;\n    border: none;\n    margin-left: 0;\n    font-size: 0.9em;\n    -moz-transition: all 0.2s ease-in; /* FF4+ */\n    -o-transition: all 0.2s ease-in; /* Opera 10.5+ */\n    -webkit-transition: all 0.2s ease-in; /* Saf3.2+, Chrome */\n    transition: all 0.2s ease-in;\n}\n\n.open .dropdown-toggle::after {\n    transform: rotate(180deg);\n}\n\n.dropdown-menu {\n    color: var(--gw-tieredmenu-color);\n    background-color: var(--gw-tieredmenu-background);\n    border: 1px solid var(--gw-tieredmenu-border-color);\n    box-shadow: var(--gw-tieredmenu-shadow-1-offset-x) var(--gw-tieredmenu-shadow-1-offset-y) var(--gw-tieredmenu-shadow-1-blur) var(--gw-tieredmenu-shadow-1-spread) var(--gw-tieredmenu-shadow-1-color);\n    border-radius: 0;\n    padding: 0;\n    min-width: 100%;\n    display: none;\n    margin-top: -1em;\n    opacity: 0;\n    -moz-transition: all 150ms ease-out; /* FF4+ */\n    -o-transition: all 150ms ease-out; /* Opera 10.5+ */\n    -webkit-transition: all 150ms ease-out; /* Saf3.2+, Chrome */\n    transition: all 150ms ease-out;\n}\n\n.open > .dropdown-menu {\n    opacity: 1;\n    display: block;\n    margin-top: -1px;\n}\n\n.dropdown-item {\n    color: var(--gw-tieredmenu-item-color) !important;\n    padding: 0.5em 1.2em;\n    cursor: pointer;\n}\n\n.dropdown-item:focus, .dropdown-item:hover {\n    color: var(--gw-tieredmenu-item-focus-color);\n    background-color: var(--gw-tieredmenu-item-focus-background);\n}\n\n.btn-link + .dropdown-menu-right {\n    margin-top: 8px;\n}\n\n.dropdown-menu-right {\n    right: 3px;\n}\n\n.status-bar .dropdown-menu-right {\n    right: 0;\n}\n.collapsible-heading {\n    cursor: pointer;\n}\n.collapsible-heading.collapsed [class^=icon-] {\n    transform: rotate(-90deg);\n}\n\n.rdf-list .hidden-data-value {\n    display: none;\n}\n\n.tab-error:after {\n    font-family: 'icomoon', sans-serif !important;\n    font-size: 1em;\n    vertical-align: middle;\n    line-height: 1;\n    position: absolute;\n    left: 0.1em;\n    content: \"\\e920\";\n}\n\n/*-------------------------------------------------------------\n\tTabs\n-------------------------------------------------------------*/\n.nav-tabs {\n    font-weight: 400;\n    border-bottom-color: var(--gw-tabs-tablist-border-color);\n}\n\n.nav-tabs .nav-item {\n    margin-top: 4px;\n    margin-right: .2rem;\n}\n\n.nav-tabs .nav-item + .nav-item {\n    margin-left: 0;\n    margin-right: .2rem;\n}\n\n.nav-tabs .nav-link {\n    border-radius: 0;\n    cursor: pointer;\n    color: var(--gw-tabs-tab-color);\n    background-color: var(--gw-tabs-tab-background);\n    border-color: var(--gw-tabs-tab-border-color);\n    border-bottom-color: var(--gw-tabs-tab-border-bottom-color);\n}\n\n.nav-tabs .nav-link:hover {\n    color: var(--gw-tabs-tab-hover-color);\n    background-color: var(--gw-tabs-tab-hover-background);\n    border-color: var(--gw-tabs-tab-hover-border-color);\n    border-bottom-color: var(--gw-tabs-tab-hover-border-bottom-color);\n}\n\n.nav-tabs .nav-link .btn {\n    padding: 0;\n    border: none;\n}\n\n.nav-tabs .nav-link > span + .btn {\n    margin-left: 0.8em;\n}\n\n.nav-tabs .active .nav-link,\n.nav-tabs .active.nav-link {\n    color: var(--gw-tabs-tab-active-color);\n    background-color: var(--gw-tabs-tab-active-background);\n    border-color: var(--gw-tabs-tab-active-border-color);\n    border-bottom-color: var(--gw-tabs-tab-active-border-bottom-color);\n}\n\n.nav-tabs .nav-link.active:hover {\n    color: var(--gw-tabs-tab-active-color);\n    background-color: var(--gw-tabs-tab-active-background);\n    border-color: var(--gw-tabs-tab-active-border-color) var(--gw-tabs-tab-active-border-color) transparent;\n}\n\n.nav-tabs .nav-link.active:focus {\n    color: var(--gw-tabs-tab-active-color);\n    background-color: var(--gw-tabs-tab-active-background);\n    border-color: var(--gw-tabs-tab-active-border-color) var(--gw-tabs-tab-active-border-color) transparent;\n}\n\n.nav-tabs .nav-item.active a,\n.nav-tabs .nav-item.active:focus a,\n.nav-tabs .nav-item.active:hover a {\n    color: var(--gw-tabs-tab-active-color);\n    background-color: var(--gw-tabs-tab-active-background);\n    border-color: var(--gw-tabs-tab-active-border-color) var(--gw-tabs-tab-active-border-color) transparent;\n}\n\n.nav-tabs .nav-link:focus {\n    border-color: var(--gw-tabs-tab-hover-border-color) var(--gw-tabs-tab-hover-border-color) transparent;\n}\n\ntab-heading.nav-item {\n    margin-right: 4px;\n}\n\n/*-------------------------------------------------------------\n\tLists\n-------------------------------------------------------------*/\nul[class*=\"style-\"] {\n    list-style: none;\n    padding: 0;\n    margin-bottom: 1.2em;\n}\n\nul[class*=\"style-\"] li {\n    padding-left: 1.6em;\n    position: relative;\n    line-height: 1.2;\n    margin-bottom: 0.6em;\n}\n\nul[class*=\"style-\"] li:before {\n    content: \"\\e91b\";\n    font-family: 'icomoon', sans-serif !important;\n    position: absolute;\n    left: 0;\n    top: -0.07em;\n    font-size: 1.2em;\n    color: var(--gw-tertiary-base);\n}\n\n.text-white ul[class*=\"style-\"] li:before {\n    color: #fff;\n}\n\nul.style-caret li:before {\n    content: \"\\e91b\";\n}\n\nul.style-check li:before {\n    content: \"\\e914\";\n}\n\nul.style-arrow li:before {\n    content: \"\\e902\";\n}\n\n/*-------------------------------------------------------------\n\tTables\n-------------------------------------------------------------*/\n.table td, .table th {\n    padding: .8rem;\n    border-color: #ddd;\n    vertical-align: middle;\n}\n\n.table th {\n    font-weight: 500;\n    vertical-align: middle;\n    color: var(--gw-datatable-header-color);\n    background-color: var(--gw-datatable-header-background);\n    border-color: var(--gw-datatable-header-cell-border-color);\n}\n\n.table tr {\n    color: var(--gw-datatable-row-color);\n    background-color: var(--gw-datatable-row-background);\n}\n\n.table td {\n    border-color: var(--gw-datatable-body-cell-border-color);\n}\n\n.table-hover tbody tr:hover,\n.table-striped tbody tr:nth-of-type(odd):hover {\n    background-color: var(--gw-datatable-row-hover-background);\n    color: var(--gw-datatable-row-hover-color);\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n    background-color: var(--gw-datatable-row-striped-background);\n}\n\n.table-sm td, .table-sm th {\n    padding: 0.3rem 0.5rem;\n}\n\n.table-info, .table-info > td, .table-info > th {\n    color: var(--gw-datatable-row-selected-color);\n    background-color: var(--gw-datatable-row-selected-background);\n}\n\n.table-hover .table-info:hover,\n.table-hover .table-info:hover > td, .table-hover .table-info:hover > th {\n    color: var(--gw-datatable-row-hover-color);\n    background-color: var(--gw-datatable-row-hover-background);\n}\n\n/*-------------------------------------------------------------\n\tModals\n-------------------------------------------------------------*/\n.modal-content {\n    border-radius: var(--gw-dialog-border-radius);\n    border: 1px solid var(--gw-dialog-border-color);\n    max-height: 90vh;\n    flex-direction: column;\n    justify-content: space-between;\n    display: flex;\n    color: var(--gw-dialog-color);\n    background-color: var(--gw-dialog-background);\n    -webkit-box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);\n    box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);\n\n    & pre {\n        color: var(--gw-dialog-color);\n        background-color: var(--gw-dialog-background);\n    }\n}\n\n.modal-content .modal-header {\n    border-bottom: 1px solid var(--gw-dialog-border-color);\n}\n\n.modal-content .modal-header .close {\n    margin-top: 4px;\n}\n\n.modal-content .modal-header,\n.modal-content .modal-footer {\n    flex: 0 0 auto;\n}\n\n.modal-content .modal-body {\n    flex: 1;\n    min-height: 0;\n    overflow: auto;\n}\n\n.modal-content .modal-footer {\n    border-top: 1px solid var(--gw-dialog-border-color);\n}\n\n/*-------------------------------------------------------------\n\tProgress bars\n-------------------------------------------------------------*/\n.progress {\n    display: block;\n    overflow: hidden;\n    font-size: 1.2rem;\n    line-height: 2rem;\n    height: 2rem;\n    background-color: var(--gw-progressbar-background);\n}\n\n.progress-bar {\n    height: 2rem;\n    color: var(--gw-progressbar-label-color);\n    background-color: var(--gw-progressbar-value-background);\n    padding: 0 0.2em;\n    text-align: center;\n}\n\n/* Square progress bar */\n.progress-square {\n    width: 3em;\n    height: 3em;\n    margin: 0 0.5em 0 0;\n    background-color: var(--gw-progressbar-background);\n    border-radius: 0.2em;\n    overflow: hidden;\n    position: relative;\n}\n\n.progress-square .progress-bar {\n    width: 100%;\n    display: block;\n    color: var(--gw-progressbar-label-color);\n    background-color: var(--gw-progressbar-value-background);\n    position: absolute;\n    bottom: 0;\n}\n\n.progress-square.warning .progress-bar {\n    background-color: #f0ad4e;\n}\n\n/*-------------------------------------------------------------\n\tUtilities\n-------------------------------------------------------------*/\ncode {\n    padding-top: 0.1rem;\n    padding-bottom: 0.1rem;\n    color: inherit;\n    background-color: inherit;\n}\n.d-flex {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.loader {\n    display: inline-block;\n    animation: load8 2s infinite linear;\n}\n\n.close {\n    font-weight: 300;\n    font-size: 1.4em;\n    opacity: 1;\n    text-shadow: none;\n}\n\n.close:focus {\n    outline: 0;\n}\n\n.close::before {\n    font-family: 'icomoon', sans-serif !important;\n    content: \"\\e922\";\n    -moz-transition: all 0.18s ease-out; /* FF4+ */\n    -o-transition: all 0.18s ease-out; /* Opera 10.5+ */\n    -webkit-transition: all 0.18s ease-out; /* Saf3.2+, Chrome */\n    transition: all 0.18s ease-out;\n    display: block;\n    color: var(--gw-dialog-color);\n}\n\n.close:focus, .close:hover {\n    opacity: 1;\n}\n\n.close:hover::before {\n    transform: scale(1.2);\n    color: var(--gw-primary-base);\n}\n\n.close.absolute {\n    position: absolute;\n    right: 1rem;\n    top: 1rem;\n}\n\n.small, small {\n    line-height: 1.25;\n}\n\n.break-word {\n    word-break: break-all;\n}\n\n.break-word-alt {\n    word-wrap: break-word;\n    word-break: break-word;\n}\n\n.data-value {\n    color: var(--gw-secondary-base);\n    font-weight: 400;\n}\n\n.data-value.big {\n    display: block;\n    font-size: 1.5em;\n    line-height: 1;\n}\n\n.d-inline-block.valign-top {\n    vertical-align: top;\n}\n\n.dot-separator:after {\n    content: \"\\b7\"; /* middot */\n    margin: 0 0.5em;\n}\n\n.dot-separator:last-of-type:after {\n    content: none;\n    margin: 0;\n}\n\n.tag {\n    font-weight: 500;\n    border-radius: 0;\n    vertical-align: 0.1em;\n}\n\n.tag-primary {\n    background-color: var(--gw-tag-primary-background);\n}\n\n.tag-inverse {\n    color: rgba(0, 0, 0, 0.7);\n}\n\n.text-overflow {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.table .text-overflow {\n    max-width: 300px;\n}\n\n@media (min-width: 1024px) {\n    .table .text-overflow {\n        max-width: 450px\n    }\n}\n\n@media (min-width: 1440px) {\n    .table .text-overflow {\n        max-width: 650px\n    }\n}\n\n@media (min-width: 1600px) {\n    .table .text-overflow {\n        max-width: 850px\n    }\n}\n\n/*-------------------------------------------------------------\n\tCards\n-------------------------------------------------------------*/\n.card {\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);\n    border-radius: 0;\n    margin-bottom: 1em;\n    color: var(--gw-panel-color);\n    background-color: var(--gw-panel-background);\n    border-color: var(--gw-panel-border-color);\n}\n\n.card-header {\n    padding: 0.75em 1.8rem;\n    color: var(--gw-panel-header-color);\n    background-color: var(--gw-panel-header-background);\n}\n\n.card.inline {\n    display: inline-block;\n    width: 19.5rem;\n    margin-right: 1em;\n    vertical-align: top;\n    overflow: hidden;\n}\n\n.card.inline .card-title {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.card.inline .card-block {\n    min-height: 165.19px;\n}\n\n.card-block {\n    padding: 1.6rem;\n}\n\n.card-footer:last-child {\n    border-radius: 0;\n}\n\n.card.button {\n    width: 10em;\n}\n\n.card.button:hover {\n    border-color: var(--gw-primary-hover-color);\n}\n\n.card.button .card-block {\n    padding: 0;\n}\n\n.card.button .btn {\n    white-space: normal;\n    padding: 0 1.8rem;\n    line-height: 218px;\n\n}\n\n.card.button .btn > span {\n    display: inline-block;\n    line-height: 1.25;\n    vertical-align: middle;\n}\n\n.card.button .btn:hover {\n    background-color: var(--gw-primary-hover-color);\n}\n\n.card.button .btn [class^=\"icon-\"] {\n    display: block;\n    font-size: 3em;\n    margin-bottom: 0.4em;\n}\n\n.card.active {\n    border-color: var(--gw-secondary-base);\n    min-height: 300px;\n}\n\n.card.active .card-footer {\n    background-color: var(--gw-secondary-base);\n    color: #fff;\n    border-color: var(--gw-secondary-base);\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n\n.card.active .card-footer .text-muted {\n    color: #fff !important;\n    font-weight: 500;\n}\n\n.card .list-group-item {\n    border-left: none;\n    border-right: none;\n}\n\n.card .alert {\n    margin-bottom: 0;\n}\n\n.actions-bar .btn {\n    padding: 0.1em;\n    background-color: transparent;\n}\n\n.actions-bar-inline .btn {\n    padding-top: 0;\n    margin-top: -0.1em;\n    padding-bottom: 0.3em;\n}\n\n.actions-bar .btn:hover {\n}\n\n.hovered-parent .hovered-item {\n    opacity: 0;\n}\n\n.hovered-parent:hover .hovered-item {\n    opacity: 1;\n}\n\n/*-------------------------------------------------------------\n\tPopovers\n-------------------------------------------------------------*/\n.popover,\n.popover pre {\n    color: var(--gw-dialog-color);\n    background-color: var(--gw-dialog-background);\n}\n\n.popover {\n    border-radius: 0;\n    -webkit-box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);\n    box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);\n    border: 1px solid var(--gw-dialog-border-color);\n    padding: 0;\n    font-family: inherit;\n}\n\n.popover-content {\n    padding: 1em;\n}\n\n.popover-title {\n    border-radius: 0;\n    background-color: var(--gw-dialog-background);\n}\n\n/* popover arrows from bootstrap 3 (needed because of angular bootstrap controls which use the old markup) */\n.popover.top {\n    margin-top: -10px;\n}\n\n.popover.right {\n    margin-left: 10px;\n}\n\n.popover.bottom {\n    margin-top: 10px;\n}\n\n.popover.left {\n    margin-left: -10px;\n}\n\n.popover .arrow,\n.popover .arrow:after {\n    position: absolute;\n    display: block;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n}\n\n.popover .arrow {\n    border-width: 11px;\n}\n\n.popover .arrow:after {\n    border-width: 10px;\n    content: \"\";\n}\n\n.popover.top .arrow {\n    bottom: -11px;\n    left: 50%;\n    margin-left: -11px;\n    border-top-color: var(--gw-dialog-border-color);\n    border-bottom-width: 0;\n}\n\n.popover.top .arrow:after {\n    bottom: 1px;\n    margin-left: -10px;\n    border-top-color: var(--gw-dialog-background);\n    border-bottom-width: 0;\n    content: \" \";\n}\n\n.popover.right .arrow {\n    top: 50%;\n    left: -11px;\n    margin-top: -11px;\n    border-right-color: var(--gw-dialog-border-color);\n    border-left-width: 0;\n}\n\n.popover.right .arrow:after {\n    bottom: -10px;\n    left: 1px;\n    border-right-color: var(--gw-dialog-background);\n    border-left-width: 0;\n    content: \" \";\n}\n\n.popover.bottom .arrow {\n    top: -11px;\n    left: 50%;\n    margin-left: -11px;\n    border-bottom-color: var(--gw-dialog-border-color);\n    border-top-width: 0;\n}\n\n.popover.bottom .arrow:after {\n    top: 1px;\n    margin-left: -10px;\n    border-bottom-color: var(--gw-dialog-background);\n    border-top-width: 0;\n    content: \" \";\n}\n\n.popover.left .arrow {\n    top: 50%;\n    right: -11px;\n    margin-top: -11px;\n    border-left-color: var(--gw-dialog-border-color);\n    border-right-width: 0;\n}\n\n.popover.left .arrow:after {\n    right: 1px;\n    bottom: -10px;\n    border-left-color: var(--gw-dialog-background);\n    border-right-width: 0;\n    content: \" \";\n}\n\n/*-------------------------------------------------------------\n\tTooltips\n-------------------------------------------------------------*/\n.angular-tooltip {\n    max-width: 300px;\n    color: var(--gw-tooltip-color);\n    background-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-top:after {\n    border-top-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-top-left:after {\n    border-top-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-top-right:after {\n    border-top-color: var(--gw-tooltip-background);\n}\n\n\n.angular-tooltip.angular-tooltip-right-top:after {\n    border-right-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-right:after {\n    border-right-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-right-bottom:after {\n    border-right-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-bottom:after {\n    border-bottom-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-bottom-left:after {\n    border-bottom-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-bottom-right:after {\n    border-bottom-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-left:after {\n    border-left-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-left-bottom:after {\n    border-left-color: var(--gw-tooltip-background);\n}\n\n.angular-tooltip.angular-tooltip-left-top:after {\n    border-left-color: var(--gw-tooltip-background);\n}\n\n/*-------------------------------------------------------------\n\tList groups\n-------------------------------------------------------------*/\n.list-group {\n    color: var(--gw-listbox-color);\n    background-color: var(--gw-listbox-background);\n}\n\n.list-group .list-group-item {\n    color: var(--gw-listbox-option-color);\n    background-color: var(--gw-listbox-option-group-background);\n}\n\n.list-group .list-group-item:hover {\n    color: var(--gw-listbox-option-focus-color);\n    background-color: var(--gw-listbox-option-focus-background);\n}\n\n.list-group-item pre {\n    margin-bottom: 0;\n}\n\n.list-group.limit-height {\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.list-group-item samp, .ellipsis-block {\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.list-group.two-columns .list-group-item {\n    width: 50%;\n    float: left;\n    border-radius: 0;\n}\n\n.list-group.two-columns .list-group-item:first-child,\n.list-group.two-columns .list-group-item:nth-child(2) {\n    border-top: none;\n}\n\n.list-group.two-columns .list-group-item:last-child {\n    border-bottom: none;\n}\n\n.list-group.two-columns .list-group-item:nth-child(odd) {\n    border-right: 1px solid #ddd;\n}\n\n.card > .list-group.two-columns:first-child .list-group-item:first-child,\n.card > .list-group.two-columns:last-child .list-group-item:last-child {\n    border-radius: 0;\n}\n\n.list-group.one-column .list-group-item:first-child {\n    border-top: none;\n}\n\n.list-group.repos li {\n    cursor: pointer;\n}\n\nli.remote {\n    background: #0000000A;\n}\n\n/*-------------------------------------------------------------\n\tForms\n-------------------------------------------------------------*/\n.form-control,\n.form-control-lg {\n    color: var(--gw-form-field-color);\n    background-color: var(--gw-form-field-background);\n    border-color: var(--gw-form-field-border-color);\n}\n\n.form-control[readonly] {\n    background-color: var(--gw-form-field-read-only-background);\n}\n\n.form-control:focus,\n.form-control-lg:focus {\n    color: var(--gw-form-field-color);\n    background-color: var(--gw-form-field-background);\n    border-color: var(--gw-form-field-focus-border-color);\n}\n\n.form-control:disabled,\n.form-control-lg:disabled {\n    color: var(--gw-form-field-disabled-color);\n    background-color: var(--gw-form-field-disabled-background);\n}\n\n.form-control::placeholder,\n.form-control-lg::placeholder {\n    color: var(--gw-form-field-placeholder-color);\n}\n\n.form-control,\n.form-control-lg,\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n    border-radius: 0;\n}\n\n.form-control-lg,\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n    font-size: 1.125rem;\n}\n\n.input-group-btn {\n    padding-left: 4px;\n}\n\n.input-group-addon {\n    color: var(--gw-inputgroup-addon-color);\n    background-color: var(--gw-inputgroup-addon-background);\n    border-radius: 0;\n    border: none;\n    padding-left: 0;\n}\n\n.has-danger .input-group-addon {\n    background-color: var(--gw-inputgroup-addon-background);\n}\n\ninput.ng-invalid.ng-touched, .ng-submitted input.ng-invalid {\n    border-color: #d9534f;\n}\n\n.input-group-addon.icon {\n    background: transparent;\n    padding: 0;\n    position: absolute;\n    top: 3px;\n    bottom: 0;\n    z-index: 10;\n    left: 0.5em;\n    pointer-events: none;\n    line-height: 2;\n}\n\n.input-group-addon.icon + .form-control {\n    padding-left: 2.2em;\n}\n\n.form-control.b-0 {\n    border: 0;\n}\n\nfieldset {\n    color: var(--gw-fieldset-color);\n}\n\n/* Override checkbox and radio button styles because they inherit their look from the OS which makes them ugly and\nunresponsive to our theme. */\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    color: var(--gw-form-field-color);\n    background-color: var(--gw-form-field-background);\n    border: 1px solid var(--gw-form-field-border-color);\n    width: 1em;\n    height: 1em;\n    display: inline-block;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\ninput[type=\"radio\"] {\n    border-radius: 50%;\n}\n\ninput[type=\"checkbox\"]:checked {\n    background-color: var(--gw-primary-base);\n    border-color: var(--gw-primary-base);\n}\n\ninput[type=\"radio\"]:checked {\n    border-color: var(--gw-primary-base);\n}\n\ninput[type=\"checkbox\"]:checked::after {\n    content: \"\\2713\"; /* checkmark */\n    display: block;\n    text-align: center;\n    color: var(--gw-body-background);\n    font-size: 0.8em;\n    line-height: 1.2;\n}\n\ninput[type=\"radio\"]:checked::after {\n    content: \"\";\n    display: block;\n    width: 0.5em;\n    height: 0.5em;\n    border-radius: 50%;\n    background-color: var(--gw-primary-base);\n    margin: 0.2em;\n}\n\ninput[type=checkbox]:checked:disabled {\n    background-color: var(--gw-checkbox-checked-disabled-background);\n    border-color: var(--gw-checkbox-checked-disabled-border-color);\n}\n\n    /*-------------------------------------------------------------\n        List groups\n    -------------------------------------------------------------*/\n\n.list-group-item:last-child,\n.list-group-item:first-child {\n    border-radius: 0;\n}\n\n.border-top-0 .list-group-item:first-child {\n    border-top: 0;\n}\n\n.tuclas .tooltip-inner {\n    color: #880000;\n    background-color: #ffff66;\n    box-shadow: 0 6px 12px rgba(0,0,0,.175);\n    /*max-height: 30px;*/\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n\n    /*width: 100px;*/\n    /*word-wrap: unset;*/\n    /*white-space: unset;*/\n}\n/*-------------------------------------------------------------\n\tSwitch control\n-------------------------------------------------------------*/\n\n\nspan.switch {\n    clear: both;\n    margin: 0 5px;\n    width: 36px;\n}\n\ninput.switch:empty {\n    display: none\n}\n\ninput.switch:empty ~ label {\n    position: relative;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    margin: 0.05em 0.6em -0.05em 0;\n    vertical-align: text-bottom;\n}\n\ninput.switch:empty ~ label:before {\n    display: block;\n    content: ' ';\n    width: 2.2em;\n    height: 1.25em;\n    background-color: var(--gw-toggleswitch-background);\n    border-radius: 10em;\n    -moz-transition: all 100ms ease-in; /* FF4+ */\n    -o-transition: all 100ms ease-in; /* Opera 10.5+ */\n    -webkit-transition: all 100ms ease-in; /* Saf3.2+, Chrome */\n    transition: all 100ms ease-in;\n}\n\ninput.switch:empty ~ label:after {\n    position: absolute;\n    display: block;\n    top: 0.1em;\n    left: 0.1em;\n    content: ' ';\n    width: 1.05em;\n    height: 1.05em;\n    background-color: var(--gw-toggleswitch-handle-background);\n    border-radius: 50%;\n    -moz-transition: all 100ms ease-in; /* FF4+ */\n    -o-transition: all 100ms ease-in; /* Opera 10.5+ */\n    -webkit-transition: all 100ms ease-in; /* Saf3.2+, Chrome */\n    transition: all 100ms ease-in;\n}\n\ninput.switch:empty ~ label:hover:after {\n    background-color: var(--gw-toggleswitch-handle-hover-background);\n}\n\ninput.switch:checked ~ label:before {\n    background-color: var(--gw-toggleswitch-checked-background);\n}\n\ninput.switch:checked ~ label:hover:before {\n    background-color: var(--gw-toggleswitch-checked-hover-background);\n}\n\ninput.switch:checked ~ label:after {\n    left: 1.05em;\n    background-color: var(--gw-toggleswitch-handle-checked-background);\n}\n\ninput.switch:checked ~ label:hover:after {\n    background-color: var(--gw-toggleswitch-handle-checked-hover-background);\n}\n\n.card.active input.switch:checked ~ label:before {\n    background-color: rgba(255, 255, 255, .5);\n}\n\n.card.active input.switch:checked ~ label:after {\n    background-color: #fff;\n}\n\n/*-------------------------------------------------------------\n\tAngular Toaster messages\n-------------------------------------------------------------*/\n#toast-container .toast {\n    border-radius: 0;\n    box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);\n    position: relative;\n}\n\n#toast-container > :hover {\n    box-shadow: 0 0 12px rgba(0, 0, 0, 0.6);\n}\n\n#toast-container > div:before {\n    display: block;\n    font-family: 'icomoon', sans-serif !important;\n    font-size: 2em;\n    position: absolute;\n    left: 0.3em;\n    top: 0.1em;\n}\n\n#toast-container .toast.toast-error,\n#toast-container .toast.toast-warning,\n#toast-container .toast.toast-info,\n#toast-container .toast.toast-success {\n    background-image: none !important;\n}\n\n#toast-container .toast {\n    font-size: 1.2rem;\n    opacity: 1;\n    padding: 25px 25px 25px 60px;\n    width: 450px;\n}\n\n@media (max-width: 1439px) {\n    #toast-container .toast {\n        width: 400px;\n    }\n}\n\n.toast-error {\n    background-color: var(--gw-toast-error-background) !important;\n    border-color: var(--gw-toast-error-border-color) !important;\n    color: var(--gw-toast-error-color) !important;\n}\n\n.toast-error button.toast-close-button {\n    color: var(--gw-toast-error-color);\n    opacity: 1;\n}\n\n.toast-error button.toast-close-button:hover {\n    color: var(--gw-toast-error-close-button-focus-ring-color);\n}\n\n.toast-warning {\n    background-color: var(--gw-toast-warn-background) !important;\n    border-color: var(--gw-toast-warn-border-color) !important;\n    color: var(--gw-toast-warn-color) !important;\n}\n\n.toast-warning button.toast-close-button {\n    color: var(--gw-toast-warn-color);\n    opacity: 1;\n}\n\n.toast-warning button.toast-close-button:hover {\n    color: var(--gw-toast-warn-close-button-focus-ring-color);\n}\n\n.toast-info {\n    background-color: var(--gw-toast-info-background) !important;\n    border-color: var(--gw-toast-info-border-color) !important;\n    color: var(--gw-toast-info-color) !important;\n}\n\n.toast-info button.toast-close-button {\n    color: var(--gw-toast-info-color);\n    opacity: 1;\n}\n\n.toast-info button.toast-close-button:hover {\n    color: var(--gw-toast-info-close-button-focus-ring-color);\n}\n\n.toast-success {\n    background-color: var(--gw-toast-success-background) !important;\n    border-color: var(--gw-toast-success-border-color) !important;\n    color: var(--gw-toast-success-color) !important;\n}\n\n.toast-success button.toast-close-button {\n    color: var(--gw-toast-success-color);\n    opacity: 1;\n}\n\n.toast-success button.toast-close-button:hover {\n    color: var(--gw-toast-success-close-button-focus-ring-color);\n}\n\n.toast-error:before,\n.toast-warning:before,\n.toast-info:before,\n.toast-success:before {\n    font-family: 'icomoon', sans-serif !important;\n    font-size: 1.5em;\n    position: absolute;\n    left: 0.6em;\n    display: block;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -moz-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n.toast-info:before {\n    content: \"\\e924\";\n}\n\n.toast-warning:before {\n    content: \"\\e930\";\n}\n\n.toast-error:before {\n    content: \"\\e920\";\n}\n\n.toast-success:before {\n    content: \"\\e914\";\n}\n\n\n#toast-container > .toast-error:before,\n#toast-container > .toast-warning:before {\n    content: \"\\e920\";\n}\n\n#toast-container > .toast-success:before {\n    content: \"\\e914\";\n}\n\n#toast-container > .toast-info:before {\n    content: \"\\e924\";\n}\n\n#toast-container > .toast-info {\n    background-color: #10b0a0;\n}\n\n#toast-container > :hover {\n    box-shadow: 0 0 12px rgba(0, 0, 0, 0.5) !important;\n}\n\n#toast-container .toast-title {\n    font-weight: 500;\n}\n\n/*-------------------------------------------------------------\n\tTutorial\n-------------------------------------------------------------*/\n\n.pages-wrapper {\n    position: relative;\n    overflow: hidden;\n}\n\n.page-slide {\n    position: absolute;\n    -moz-transition: left 0.18s ease-out; /* FF4+ */\n    -o-transition: left 0.18s ease-out; /* Opera 10.5+ */\n    -webkit-transition: left 0.18s ease-out; /* Saf3.2+, Chrome */\n    transition: left 0.18s ease-out;\n}\n\n.tutorial-container .pages-wrapper {\n    min-height: 300px;\n}\n\n.page-slide ul {\n    list-style-type: none;\n    margin-top: 16px;\n}\n\n/*-------------------------------------------------------------\n\tSearch RDF resource box\n-------------------------------------------------------------*/\n\n#auto-complete-results-wrapper {\n    max-height: 204px;\n    overflow: auto;\n    color: var(--gw-autocomplete-color);\n    background-color: var(--gw-autocomplete-background);\n}\n\n#auto-complete-results-wrapper div:hover,\n#auto-complete-results-wrapper div.active {\n    color: var(--gw-autocomplete-option-focus-color);\n    background-color: var(--gw-autocomplete-option-focus-background);\n    cursor: pointer;\n}\n\n#auto-complete-results-wrapper div.selected {\n    color: var(--gw-autocomplete-option-selected-color);\n    background-color: var(--gw-autocomplete-option-selected-background);\n    cursor: pointer;\n}\n\n#auto-complete-results-wrapper div p b,\n#auto-complete-results-wrapper div.active p b {\n    color: var(--gw-autocomplete-dropdown-match-color);\n}\n\n#auto-complete-results-wrapper div p {\n    margin-bottom: 0;\n    padding: 5px 25px;\n}\n\n#search-resource-box {\n    .clear-icon {\n        position: relative;\n        right: 45px;\n        z-index: 10;\n        float: none;\n    }\n\n    .display-type-table-btn.active,\n    .display-type-visual-btn.active {\n        color: var(--gw-button-primary-hover-color);\n        background-color: var(--gw-button-primary-background);\n        border-color: var(--gw-button-primary-border-color);\n    }\n}\n\n/*-------------------------------------------------------------\n\tAnimations\n-------------------------------------------------------------*/\n@keyframes load8 {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(-360deg);\n        transform: rotate(-360deg);\n    }\n}\n\n/*-------------------------------------------------------------\n\tPaggination - Export view\n-------------------------------------------------------------*/\n\nul.nav.navbar-right.pagination li {\n    float: left;\n}\n\nul.nav.navbar-right.pagination li:hover a {\n    text-decoration: none;\n}\n\nul.nav.navbar-right.pagination li.disabled a {\n    color: rgba(0, 0, 0, 0.5) !important;\n    pointer-events: none;\n}\n\n/*-------------------------------------------------------------\n\tPaggination\n-------------------------------------------------------------*/\n.pagination > li > a {\n    color: var(--gw-paginator-nav-button-color);\n    background-color: var(--gw-paginator-nav-button-background);\n}\n\n.pagination > .active > a {\n    color: var(--gw-paginator-nav-button-selected-color);\n    background-color: var(--gw-paginator-nav-button-selected-background);\n}\n\n.pagination > li > a:hover {\n    color: var(--gw-paginator-nav-button-hover-color);\n    background-color: var(--gw-paginator-nav-button-hover-background);\n}\n\n@media (max-width: 1439px) {\n    .yasr .dataTables_wrapper .dataTables_filter input, .yasr .openGchartBtn {\n        margin-top: 8px;\n    }\n}\n\n.yasr .pivotTable {\n    overflow-y: auto;\n}\n\n.btn.btn-primary.btn-sm.yasr_downloadIcon {\n    margin-right: 6px;\n}\n\n/*-------------------------------------------------------------\n\tSave as dropdown yasr SPARQL\n-------------------------------------------------------------*/\n\n.saveAsDropDown.btn-group .btn.btn-primary.btn-sm.dropdown-toggle, .yasr_downloadIcon, .resultsVisualButton button {\n    font-size: 16px;\n    padding: 10px 16px;\n    margin-top: 4px;\n}\n\n/*-------------------------------------------------------------\n\tSPARQL editor\n-------------------------------------------------------------*/\n.dialog .dialog-footer .confirm-button {\n    background-color: var(--gw-primary-base) !important;\n}\n\n\nyasgui-component .yasgui-btn.btn-selected {\n    background-color: var(--gw-primary-base) !important;\n}\n\nyasgui-component .btn-orientation {\n    color: var(--gw-primary-base) !important;\n}\n\nyasgui-component .custom-button {\n    color: var(--gw-primary-base) !important;\n}\n\nyasgui-component .ok-button,\nyasgui-component .primary-button,\nyasgui-component .confirm-button {\n    background-color: var(--gw-primary-base) !important;\n}\n\nyasgui-component .yasr .dataTable a {\n    font-size: 16px;\n}\n\nyasgui-component .yasr_response_chip {\n    font-size: 16px;\n    color: var(--gw-secondary-base) !important;\n}\n\nyasgui-component .yasr_plugin_control label {\n    color: var(--gw-secondary-base) !important;\n    margin-bottom: 0;\n}\n\nyasgui-component .yasr_plugin_control label .label {\n    margin-right: 5px;\n}\n\n/* End of yasgui-component style overrides */\n.dialog .dialog-footer .confirm-button {\n    background-color: var(--gw-primary-base) !important;\n}\n\n.nav-item.sparql-tab a.nav-link {\n    max-width: 250px;\n    padding-right: 20px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: relative;\n}\n\n.nav-item.sparql-tab a.nav-link .btn.btn-link {\n    position: absolute;\n    right: 4px;\n    top: 11px;\n}\n\n.nav-item.sparql-tab a.nav-link span {\n    padding-right: 10px;\n}\n\n/*-------------------------------------------------------------\n    Namespaces view\n-------------------------------------------------------------*/\ninput[name=namespace] {\n    width: 55%;\n    float: left;\n}\n\n.showing-info-namespaces {\n    margin-top: 16px;\n}\n\n/*-------------------------------------------------------------\n    Domain-Range graph side menu\n-------------------------------------------------------------*/\n\n.rdf-side-panel-content ul.rdf-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.rdf-side-panel-content ul.rdf-list li {\n    position: relative;\n    padding: 5px 50px 5px 10px;\n}\n\n.rdf-side-panel-content ul.rdf-list li svg {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    pointer-events: none;\n}\n\n.rdf-side-panel-content ul.rdf-list li:nth-of-type(odd) {\n    background-color: rgba(0, 0, 0, .05);\n\n}\n\n.rdf-side-panel-content ul.rdf-list li {\n    border-top: 1px solid #ddd;\n    padding: 10px;\n}\n\n/*-------------------------------------------------------------\n    Class hierarchy view\n-------------------------------------------------------------*/\n\n.slider-help-button .help-button {\n    padding: 0;\n    position: absolute;\n    right: -25px;\n    top: -1px;\n}\n\n.slider-help-button .help-button .ri-information-2-line {\n    font-size: 1.2em;\n}\n\n.slider-help-button {\n    position: relative;\n    left: -16px;\n}\n\n/*-------------------------------------------------------------\n    Internet explorer fixes\n-------------------------------------------------------------*/\n\n/*Disable search graphs input clear and input reveal*/\n::-ms-clear {\n    display: none;\n}\n\n::-ms-reveal {\n    display: none;\n}\n\n/*-------------------------------------------------------------\n    Slide up and down view resource container\n-------------------------------------------------------------*/\n\n.slider {\n    overflow-y: hidden;\n}\n\n.slider.closed {\n    max-height: 0;\n    -moz-transition: max-height 0.5s ease-out; /* FF4+ */\n    -o-transition: max-height 0.5s ease-out; /* Opera 10.5+ */\n    -webkit-transition: max-height 0.5s ease-out; /* Saf3.2+, Chrome */\n    transition: max-height 0.5s ease-out;\n}\n\n.slider.opened {\n    -moz-transition: max-height 0.5s ease-in; /* FF4+ */\n    -o-transition: max-height 0.5s ease-in; /* Opera 10.5+ */\n    -webkit-transition: max-height 0.5s ease-in; /* Saf3.2+, Chrome */\n    transition: max-height 0.5s ease-in;\n}\n\n/*-------------------------------------------------------------\n    Graphs visualizations side panel\n-------------------------------------------------------------*/\n\n.rdf-side-panel-content .tab-content {\n    overflow-y: auto;\n    width: 100%;\n    max-height: calc(100vh - 130px);\n}\n\n.menu-events g {\n    cursor: pointer;\n    opacity: 0;\n}\n\n.tags .tag-list li.tag-item {\n    height: auto !important;\n    white-space: normal !important;\n}\n\n\n/*-------------------------------------------------------------\n    Badges\n-------------------------------------------------------------*/\n.badge {\n    display: inline-block;\n    padding: .25em .4em;\n    font-size: 75%;\n    font-weight: 400;\n    line-height: 1;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: .25rem;\n}\n.badge-default  { background-color: #aaa }\n.badge-primary  { background-color: var(--gw-secondary-base) }\n.badge-info     { background-color: var(--gw-primary-base) }\n.badge-success  { background-color: #5cb85c }\n.badge-warning  { background-color: #f0ad4e }\n\n/*-------------------------------------------------------------\n    Columns\n-------------------------------------------------------------*/\n@media (min-width: 992px) {\n    .col-lg-no-padding {\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    }\n}\n\n/*-------------------------------------------------------------\n    Custom tags-input styling, overrides some\n    of the styles from ng-tags-input.min.css\n-------------------------------------------------------------*/\ntags-input[disabled] .tags {\n    color: var(--gw-form-field-disabled-color);\n    background-color: var(--gw-form-field-disabled-background) !important;\n}\n\ntags-input[disabled] .tags .input {\n    color: var(--gw-form-field-disabled-color);\n    background-color: var(--gw-form-field-disabled-background) !important;\n}\n\ntags-input .tags .input {\n    color: var(--gw-form-field-color);\n    background-color: var(--gw-form-field-background);\n}\n\n.wb-tags-input .tags {\n    background-color: var(--gw-form-field-background);\n    border: 1px solid var(--gw-form-field-border-color);\n    border-radius: 0;\n    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);\n    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n\n.wb-tags-input .tags.focused {\n    outline: 0;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #cbeeea;\n    -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #cbeeea;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #cbeeea;\n}\n\n.wb-tags-input .tags .tag-item {\n    background: #cbeeea;\n    border: 1px solid #cbeeea;\n    border-radius: 0;\n    color: #3D3D3D;\n}\n\n.wb-tags-input .tags .tag-item.tag-item-wildcard {\n    background: #cbeeea;\n    border: 1px solid #cbeeea;\n    border-radius: 0;\n    color: #3D3D3D;\n    font-weight: bold;\n}\n\n.wb-tags-input .tags .tag-item .remove-button {\n    margin: 0 0 0 5px;\n    padding: 0;\n    border: none;\n    background: 0 0;\n    cursor: pointer;\n    vertical-align: middle;\n    font: 700 16px Arial,sans-serif;\n    color: #7e7b6d;\n}\n\n/*-------------------------------------------------------------\n\tMain menu\n-------------------------------------------------------------*/\n.repo-info-home {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n}\n\n.repo-info-home div {\n    align-self: center;\n}\n\n.tag-default {\n    color: var(--gw-tag-default-color) !important;\n    background-color: var(--gw-tag-default-background) !important;\n}\n\n.tag-danger {\n    color: var(--gw-tag-danger-color) !important;\n    background-color: var(--gw-tag-danger-background) !important;\n}\n\n.tag-success {\n    color: var(--gw-tag-success-color) !important;\n    background-color: var(--gw-tag-success-background) !important;\n}\n\n.tag-warning {\n    color: var(--gw-tag-warning-color) !important;\n    background-color: var(--gw-tag-warning-background) !important;\n}\n\n.tag-info {\n    color: var(--gw-tag-info-color) !important;\n    background-color: var(--gw-tag-info-background) !important;\n}\n\n.rzslider .rz-pointer {\n    background-color: var(--gw-slider-handle-focus-ring-color) !important;\n    outline: none !important;\n}\n\n.rzslider .rz-pointer:hover {\n    background-color: var(--gw-slider-handle-hover-background) !important;\n}\n\n.rzslider .rz-pointer:after {\n    background-color: var(--gw-slider-track-background) !important;\n}\n\n.rzslider .rz-pointer.rz-active:after {\n    background-color: var(--gw-slider-range-background) !important;\n}\n\n.rzslider .rz-bar {\n    background-color: var(--gw-slider-track-background) !important;\n}\n\n.rzslider .rz-selection {\n    background: var(--gw-slider-range-background) !important;\n}\n\n.rzslider .rz-bubble.rz-limit,\n.rzslider .rz-bubble {\n    color: var(--gw-slider-label-color) !important;\n}\n\n.login-form {\n    max-width: 600px;\n    padding-top: 4em;\n    margin: auto;\n}\n\n.btn-fade-warning {\n    animation: fade-button 2s infinite;\n    --fade-color: var(--gw-warning-lighter);\n}\n\n.btn-fade-danger {\n    animation: fade-button 2s infinite;\n    --fade-color: var(--gw-error-lighter);\n}\n\n.btn-fade-warning:hover, .btn-fade-danger:hover {\n    background-color: var(--fade-color) !important;\n    border-color: var(--fade-color) !important;\n}\n\n@keyframes fade-button {\n    from {\n        background-color: transparent;\n        border-color: transparent;\n    }\n    50% {\n        background-color: var(--fade-color);\n        border-color: var(--fade-color);\n    }\n    to {\n        background-color: transparent;\n        border-color: transparent;\n    }\n}\n\n.ot-loader-new-content circle {\n    fill: var(--gw-loader-color)\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
